// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import checkIcon from "@/assets/icons/check.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type CheckIconProps = Omit<IconProps, "name">;

export function CheckIcon(props: CheckIconProps): React.ReactNode {
  return <Icon name={checkIcon} {...props} />;
}
